import React from "react";
import { Row, Col } from "react-bootstrap";
import { useQuery } from "@apollo/client";

import DeqPieChart from "../../reuseableComponents/graphsAndCharts/DeqPieChart";
import ChartLegend from "../../reuseableComponents/graphsAndCharts/ChartLegend";
import { GET_POP_SERVED_BY_WATERSYS_RATING } from "../../../queries/archiveQrys/secureQrys/statewideReportQry";
import SkeletonLoader from "../../reuseableComponents/loaders/SkeletonLoader";
import ErrorHandler from "../../reuseableComponents/ErrorHandler";

const PopSerevedBywaterSysRatingChart = () => {
  const { loading, data, error } = useQuery(GET_POP_SERVED_BY_WATERSYS_RATING);

  if (loading || error) {
    return (
      <>
        <Row>
          <Col>
            <h3>Population Served By Water System Ratings</h3>
          </Col>
        </Row>
        <Row>
          <Col>{loading ? <SkeletonLoader width='100%' /> : error ? <ErrorHandler error={error} /> : ""}</Col>
        </Row>
      </>
    );
  }
  const colors = ["#0080b7", "#00afd8", "#636363", "#add361", "#5fa7be"];
  return (
    <>
      <Row>
        <Col>
          <h3>Population Served By Water System Ratings</h3>
        </Col>
      </Row>
      <Row>
        <Col cypressid='popServedByWtrSysRatingLegend'>
          <ChartLegend data={data.getCommutnityWaterSystsemCountsByPopulationServed} colorArray={colors} />
        </Col>
      </Row>
      <Row>
        <Col cypressid='popServedByWtrSysRatingChart'>
          <DeqPieChart data={data.getCommutnityWaterSystsemCountsByPopulationServed} colorArray={colors} />
        </Col>
      </Row>
    </>
  );
};
export default PopSerevedBywaterSysRatingChart;
